























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {BaseStation, Column} from '@/types/core';

import VueError from '@/components/VueError.vue';
import EnterpriseId from '@/components/EnterpriseId.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';

import tippy from 'tippy.js';
import MobileFriendlyRow from "@/components/MobileFriendlyRow.vue";

@Component({
  components:{
    MobileFriendlyRow,
    VueError,
    EnterpriseId,
    TimestampAgo
  }
})
export default class BssRow extends Vue {

  error:string = '';
  expand:boolean = false;
  pressTimer:any = null;
  @Prop({ default: {},  type: Object}) bss!: BaseStation;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;

  cols:Column[] = [
    {colName:'lrrId', colStyle:{'flex-grow':1, 'min-width': '75px'},colKey:'lrrId'},
    {colName:'type', colStyle:{width:'25%'}, colKey:'commercialName'},
    {colName:'health / status', colStyle: {width: '35%'},  colKey:'healthStatus'},
  ]
  
  async mounted() {
    // nothing yet

    tippy('[data-tippy-content]');
  }


  startToggleTimer(evt:any){
      this.pressTimer = setTimeout(()=>{
          evt.preventDefault()
          this.pressTimer = null
      },100)
  }

  toggleExpansion(){
      this.expand = !this.expand
  }

  maybeToggleExpansion(){
      if(this.pressTimer){
          clearTimeout(this.pressTimer)
          this.toggleExpansion()
      }
  }
}

